import Navigation from '@/components/Navigation';
import { PlatformEngineeringHero } from '@/components/marketing/PlatformEngineeringHero';
import { CoreCapabilitiesSection } from '@/components/marketing/CoreCapabilitiesSection';
import { TechnicalArchitectureSection } from '@/components/marketing/TechnicalArchitectureSection';
import { QuickStartSection } from '@/components/marketing/QuickStartSection';
import { Link } from 'react-router-dom';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Per convoy-011 scope ("sidebar or top nav"): top Navigation header provides persistent desktop nav on home (full-width marketing).
          Recovery narrative + IDP tools links in footer + hero sections. App pages use DesktopSidebar for persistent tools nav (incl. IDP Templates first). */}
      <Navigation />
      <main>
        <PlatformEngineeringHero />

        {/* Thin bridge — recovery context only. The hero visualization + primary CTAs already communicate the value instantly.
            Per convoy-011 + DESIGN_FUNCTIONAL_INSPIRATION_PATH: external entry is the functional viz, not copy or duplicate CTAs. */}
        <div className="border-t border-[var(--border)]" />

        <CoreCapabilitiesSection />
        <TechnicalArchitectureSection />
        <QuickStartSection />
      </main>

      {/* Footer - modernized to DESIGN.md calm Nordic tokens, recovery vision impact */}
      <footer className="bg-[var(--background)] border-t border-[var(--border)] py-12 text-[var(--foreground)]">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-semibold mb-4 tracking-tight">Platform Engineering Nexus</h3>
              <p className="text-[var(--muted-foreground)] text-sm leading-relaxed text-measure content-container">
                The calm, well-architected control center for platform work. Collaborative
                &quot;GitHub for platform engineering artifacts&quot; — IDP templates, Canvas
                visualization, cyber risk + OSINT awareness, automated exports.
              </p>
              <p className="mt-3 text-xs text-[var(--muted-foreground)]">
                Recovery mission active: re-aligning to original IDP automation builder vision.
              </p>
            </div>

            <div>
              <h4 className="font-medium mb-4 tracking-tight text-[var(--primary)]">Platform</h4>
              <ul className="space-y-2 text-sm text-[var(--muted-foreground)]">
                <li>
                  <Link to="/canvas" className="hover:text-[var(--accent)] transition-colors">
                    Architecture Canvas (with ?template= IDP loads + risk matrix)
                  </Link>
                </li>
                <li>
                  <Link
                    to="/idp-templates"
                    className="hover:text-[var(--accent)] transition-colors"
                  >
                    IDP Templates (Score concepts, Load on Canvas, Export)
                  </Link>
                </li>
                <li>
                  <Link
                    to="/idp-tools-catalog"
                    className="hover:text-[var(--accent)] transition-colors"
                  >
                    IDP Tools Catalog (live Cyber/OSINT risk badges)
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cloud-foundation"
                    className="hover:text-[var(--accent)] transition-colors"
                  >
                    Cloud Maturity
                  </Link>
                </li>
                <li>
                  <Link
                    to="/dependency-planning"
                    className="hover:text-[var(--accent)] transition-colors"
                  >
                    Dependency Planning (impact/cost modeling)
                  </Link>
                </li>
                <li>
                  <Link to="/marketplace" className="hover:text-[var(--accent)] transition-colors">
                    Marketplace
                  </Link>
                </li>
              </ul>
              <p className="text-xs text-[var(--muted-foreground)] mt-3">
                Sign in for full recovery tools
              </p>
            </div>

            <div>
              <h4 className="font-medium mb-4 tracking-tight text-[var(--primary)]">Resources</h4>
              <ul className="space-y-2 text-sm text-[var(--muted-foreground)]">
                <li>
                  <Link to="/docs" className="hover:text-[var(--accent)] transition-colors">
                    Documentation
                  </Link>
                </li>
                <li>
                  <Link
                    to="/legal/terms-of-service"
                    className="hover:text-[var(--accent)] transition-colors"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    to="/legal/privacy-policy"
                    className="hover:text-[var(--accent)] transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy-center"
                    className="hover:text-[var(--accent)] transition-colors"
                  >
                    Privacy Center
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-[var(--border)] mt-8 pt-8 text-center text-sm text-[var(--muted-foreground)]">
            <p>
              &copy; {new Date().getFullYear()} Platform Engineering Nexus. All rights reserved.
            </p>
            <p className="text-xs mt-1">
              Modern React 19 + Vite + CF Workers • Nordic design tokens • gstack verified
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
